<template>
  <div class="signin">
    <auth-container writerType="ilah">
      <sign-in-form :propEmail="email" />
    </auth-container>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignInForm from "@/components/organisms/SignInForm.vue";
import AuthContainer from "@/components/organisms/AuthContainer.vue";
import { checkDeprecatedBrowser } from "@/lib/checkDeprecatedBrowser";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    const meta = process.env.NODE_ENV !== "production" ? [{ name: "robots", content: "none" }] : [];
    return {
      title: this.$t("app.meta.signInTitle") as string,
      titleTemplate: "%s",
      meta: [
        ...meta,
        { vmid: "description", name: "description", content: this.$t("app.meta.signInDescription") as string },
        { vmid: "og:title", property: "og:title", content: this.$t("app.meta.signInTitle") as string },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.$t("app.meta.signInDescription") as string,
        },
        { vmid: "og:url", property: "og:url", content: window.location.href },
      ],
    };
  },
  components: {
    SignInForm,
    AuthContainer,
  },
  props: {
    email: String,
  },
  created() {
    /** 非推奨ブラウザへの文言表示 */
    checkDeprecatedBrowser();
  },
});
</script>

<style lang="scss" scoped>
.signin {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
}
</style>
